import React, { useEffect} from "react";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";

import MyLabel from "../../../components/myLabel";

import Modal from '@mui/material/Modal';
import MyButton from "../../../components/myButton";
import { useTheme } from "@emotion/react";
import MyInput from "../../../components/myInput";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import useTemplateListaState from "../../../hooks/useTemplateLista";
import toast from "react-hot-toast";

const ModalTemplateLista = ({open, handleClose, id}) => {
    const theme = useTheme();
    const states = useTemplateListaState()

    const handlerSalvar = (json)=>{
        states.salvarLista.set(json, handleClose)
    }   

    useEffect(()=>{
        if (open && id ){
           states.getLista.set(id)
        } else{
            states.nomeLista.set('')
            states.lista.set([])
        }
    }, [open])

    return ( 
        <Modal 
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={ {       
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '40%',
                height: '70%',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                borderRadius:5,
                p: 4,}
                }>
                <Box sx={{display:'flex', justifyContent:'end'}}>
                    <Button onClick={handleClose}>X</Button>
                </Box>
                <Box >
                    <MyLabel sx={{ fontSize: "15pt", fontWeight: 600, color:'#000'}} component='h2' text='Lista de opções'/>
                </Box>     
                <Box sx={{marginTop:'20px'}}>
                    <MyInput sx={{width:'100%'}} label='Nome da lista' type='text' value={states.nomeLista.value} onChange={(e)=>{
                                    states.nomeLista.set(e.target.value)                        
                            }}/>   
                </Box>
                <Box  sx={{display:'flex',width:'100%', marginTop:'20px'}}>
                    <Box sx={{width:'100%'}}>
                        <MyInput sx={{width:'100%'}} label='Descrição da Opção' type='text' value={states.descricaoOpcao.value} onChange={(e)=>{
                                    states.descricaoOpcao.set(e.target.value)
                                }}
                        />                    
                    </Box>
                    <Box sx={{width:'50px', display:'flex', justifyContnt:'center', alignItems:'center'}} >
                            <Tooltip title={'Adicionar Lista'} arrow>
                                <Button onClick={()=>{
                                    if (states.descricaoOpcao.value !== ''){
                                        let _lista = [...states.lista.value]
                                        _lista.push({ordem:_lista.length+1, nome:states.descricaoOpcao.value})
                                        states.descricaoOpcao.set('')
                                        states.lista.set(_lista)
                                    }
                                    else{
                                        toast.error("Atenção preencha o Campo Descrição de Opção.")

                                    }
                                    }}><AddCircleOutlineIcon />
                                </Button>
                            </Tooltip>
                    </Box>                
                </Box>
                <Box  sx={{marginTop:'20px', display:'flex', flexDirection:'row', justifyContent:'space-between', gap:"20px"}}>
                    <TableContainer sx={{height:'200px'}} component={Paper}>
                        <Table sx={{ minWidth: 600 }}  size="small">
                            <TableHead sx={{backgroundColor: theme.palette.primary.main, color:'#FFF'}}>
                                <TableRow>
                                    <TableCell sx={{color:'#FFF',width:'10%'}}>Ordem</TableCell>
                                    <TableCell sx={{color:'#FFF'}} >Opção</TableCell>
                                    <TableCell align="right" sx={{color:'#FFF'}}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {states.lista.value.sort((a, b) => a.ordem - b.ordem).map((row) => (
                                <TableRow
                                    key={row.ordem}
                                    >
                                    <TableCell component="th" scope="row">
                                        {row.ordem}
                                    </TableCell>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell align="right" sx={{color:'#FFF'}}>
                                        <Tooltip title={'Apaga opção'} arrow>
                                            <Button  color='error'  onClick={()=>{
                                                let cont = 0
                                                let _lista = states.lista.value.filter(item =>item.ordem !== row.ordem).map((item) => {
                                                        cont += 1
                                                        return {...item, ordem:cont}
                                                    })
                                                states.lista.set(_lista)
                                                }}
                                                sx={{width:'40px', padding: 0,minWidth:0}}><DeleteIcon/>
                                            </Button>
                                        </Tooltip>                                        
                                    </TableCell>                                    
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>                           

                <Box sx={{flex:'flex', flexDirection:'row', marginTop:'20px'}}>
                    <MyButton  sx={{marginRight:'20px'}} onClick={()=>handleClose()} variant='contained' text='Voltar' color='warning'/>
                    <MyButton onClick={()=>{
                            if(states.nomeLista.value){
                                let json = {
                                    nome: states.nomeLista.value,
                                    opcoes: JSON.stringify(states.lista.value)
                                }

                                if (states.lista.value.length){
                                    handlerSalvar(json)
                                } else {toast.error("Atenção preencha a lista de opções.")}
                            }else{
                                toast.error("Atenção preencha o Campo Nome da lista.")
                            }
                    }} variant='contained' text='Salvar' color='primary'/>
                </Box>
                
            </Box>

        </Modal>
    )
}

export default ModalTemplateLista